let Config = {};

Config.backEndUrl = "http://118.195.147.199:8088";

export default Config;
